import axios from "../axios";

const api = {
  getQuestionnaireById(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/supplier-questionnaires/physical-risk/${id}`, headers).then(({ data }) => data);
  },

  createNewLocation({ physicalRiskId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/physical-risk/${physicalRiskId}/location`, data, headers).then(({ data }) => data);
  },

  updateLocation({ physicalRiskId, locationId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/supplier-questionnaires/physical-risk/${physicalRiskId}/location/${locationId}`, data, headers).then(({ data }) => data);
  },

  finalizePhysicalRiskQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/physical-risk/${id}/finalize`, {}, headers).then(({ data }) => data);
  },

  getSupplierPhysicalRiskQuestionnaire(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/supplier-questionnaires/physical-risk/${id}`, headers).then(({ data }) => data);
  },
}

export default api;